export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11605.1c9643d5.jpg";